import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { selectCurrentEscritorio } from '@/features/escritorio';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { buscarAcessoSimulacao } from '../store/actions';
import { selectAcessoDaSimulacao } from '../store/selectors';

/**
 * Gate da página aberta pela URL (CA-1). Só bloqueia quando o core respondeu que não pode: falha
 * de leitura deixa a tela seguir, e cada rota do core confere EDITOR de novo (403).
 */
export function useAcessoDaSimulacao() {
  const $ = _c(11);
  const dispatch = useAppDispatch();
  const escritorioId = useAppSelector(selectCurrentEscritorio)?.id ?? null;
  const acesso = useAppSelector(selectAcessoDaSimulacao);
  const contextoId = useAppSelector(_temp);
  const trocandoEscritorio = useAppSelector(_temp2);
  const lidoParaEsteEscritorio = escritorioId !== null && acesso.carregadoPara === escritorioId;
  let t0;
  let t1;
  if ($[0] !== acesso.carregando || $[1] !== contextoId || $[2] !== dispatch || $[3] !== escritorioId || $[4] !== lidoParaEsteEscritorio) {
    t0 = () => {
      if (!escritorioId || contextoId !== null && contextoId !== escritorioId || lidoParaEsteEscritorio || acesso.carregando) {
        return;
      }
      dispatch(buscarAcessoSimulacao(escritorioId));
    };
    t1 = [acesso.carregando, dispatch, escritorioId, contextoId, lidoParaEsteEscritorio];
    $[0] = acesso.carregando;
    $[1] = contextoId;
    $[2] = dispatch;
    $[3] = escritorioId;
    $[4] = lidoParaEsteEscritorio;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
  const t2 = escritorioId === null || trocandoEscritorio || contextoId !== null && contextoId !== escritorioId;
  const t3 = contextoId ?? escritorioId;
  const t4 = lidoParaEsteEscritorio && !acesso.carregando && !acesso.podeUsar && acesso.erro === null;
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      carregandoContexto: t2,
      escritorioId: t3,
      negado: t4
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2(state_0) {
  return state_0.negociacaoSimulacao.trocandoEscritorio;
}
function _temp(state) {
  return state.negociacaoSimulacao.escritorioId;
}